/**
 * The campaign-list read of every tracker that answers in Voluum's campaign
 * shape: GET <path> → the envelope's rows, [] when absent. Voluum
 * (/voluum/campaigns, which then tags each row) and tres-commas
 * (/tres-commas/campaigns) share it.
 * For Media Devoted | Created By Ciro Autiero
 */

import api from '@/services/api';

export async function fetchCampaignList<T>(path: string): Promise<T[]> {
  const response = await api.get<{ data: T[] }>(path);
  return response.data.data ?? [];
}
